import { Component, Input } from '@angular/core';
import { DarkModeService } from '../dark-mode/dark-mode.service';

@Component({
    selector: 'app-side-img-decoration',
    templateUrl: './side-img-decoration.component.html',
    styles: [
        `
    .wf-decoration-visual {
      margin-top: 3rem !important;
    }
    @media (min-height: 1000px) {
      .wf-decoration-visual {
        margin-top: 0 !important; 
      }
    }
    `,
    ],
    host: {
        class: 'tw-relative tw-hidden tw-w-0 tw-flex-1 lgx:tw-flex lgx:tw-flex-col lgx:tw-justify-center',
    },
    standalone: false
})
export class SideImgDecorationComponent {
  constructor(public darkModeService: DarkModeService) {}

  @Input() isWorkforceLogin = false;
}
